module.exports = __webpack_public_path__ + "media/images/favicon/bg-trans-4404f93a0ddad35c05832f71db7a32c5.png";